var map = {
	"./ajax.png": "8760",
	"./arsenal.png": "c8b8",
	"./atletico-madrid.png": "ffda",
	"./barcelona.png": "ba8b",
	"./bayern-munich.png": "9c0a",
	"./benfica.png": "85d6",
	"./borussia-dortmund.png": "dc27",
	"./borussia-monchengladbach.png": "26c3",
	"./chelsea.png": "8f01",
	"./crystal-palace.png": "d4b0",
	"./eintracht-frankfurt.png": "bdc4",
	"./everton.png": "c547",
	"./internazionale.png": "2526",
	"./juventus.png": "6390",
	"./leicester-city.png": "16bf",
	"./liverpool.png": "0ea1",
	"./lyon.png": "f6f1",
	"./manchester-city.png": "212d",
	"./manchester-united.png": "3857",
	"./milan.png": "50a2",
	"./napoli.png": "ad19",
	"./paris-saint-germain.png": "09fc",
	"./real-madrid.png": "2c33",
	"./schalke-04.png": "89c2",
	"./sheffield-united.png": "87a4",
	"./tottenham-hotspur.png": "64ad",
	"./unknown.png": "cee4",
	"./valencia.png": "ddf8",
	"./west-ham-united.png": "c934",
	"./wolverhampton-wanderers.png": "e8c9",
	"./zenit-saint-petersburg.png": "636d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dfca";